// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__1GUQ2","lds-ring":"Loading_lds-ring__348HU"};